module.exports = __webpack_public_path__ + "media/images/empty-time-button-60939e20bf14beb863b48a5cb45b34bc.png";